import React from 'react';
import styled from 'styled-components';
import { TypographyComponent as TypographyElement } from '@tvg/fuse-design';

const MarginContainer = styled.div`
  margin-bottom: var(--spacing-space16);
`;

function PrfInfo({ prfValue, weeeEligibilityInd }: { prfValue?: string; weeeEligibilityInd?: boolean }): JSX.Element {
  return weeeEligibilityInd && prfValue ? (
    <TypographyElement size="m1" tag="p" type="paragraph" data-testid="prf-info-wrapper">
      {`Included in this price is a contribution to the recycling cost of ${prfValue}`}
    </TypographyElement>
  ) : (
    <MarginContainer />
  );
}

export default PrfInfo;
